import { QueryClient } from '@tanstack/react-query'
import { get, set, del } from 'idb-keyval'
import { persistQueryClient } from '@tanstack/react-query-persist-client';

import { IDB_KEY, MAX_CACHE_AGE } from './query-client.constants'

function createQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: MAX_CACHE_AGE,
      },
    },
  });

  const IDBPersister = {
    persistClient: async (client) => {
      await set(IDB_KEY, client);
    },
    restoreClient: async () => {
      return get(IDB_KEY);
    },
    removeClient: async () => {
      await del(IDB_KEY);
    },
  };

  persistQueryClient({
    queryClient,
    persister: IDBPersister,
    maxAge: MAX_CACHE_AGE,
    dehydrateOptions: {
      shouldDehydrateQuery: (query) => {
        // do not store unsuccesful queries and queries related to user
        if (query.state.status !== 'success') return false;

        return true;
      },
    },
  });

  return queryClient;
}

const queryClient = createQueryClient();

export default queryClient;